import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@beef/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../../../utils";
import { StepsSlideContext } from "../../context";
import { MobileCard } from "./components/MobileCard";
import { Heading } from "./components/Heading";
import { Card } from "./components/Card";
var _SecondarySlide = function _SecondarySlide(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    children = _ref.children;
  var _ref2 = useContext(StepsSlideContext) || {},
    isActive = _ref2.isActive,
    index = _ref2.index;
  var isMobile = useIsMobileDimension();
  if (isMobile) {
    return /*#__PURE__*/React.createElement(MobileCard, {
      isTopBorder: !!index,
      number: index + 1,
      "data-t-id": "slides-SecondarySlide"
    }, children, /*#__PURE__*/React.createElement(Heading, {
      subtitle: subtitle,
      title: title,
      "data-t-id": "slides-SecondarySlide"
    }));
  }
  return /*#__PURE__*/React.createElement(Card, {
    isActive: isActive
  }, children, /*#__PURE__*/React.createElement(Text, {
    size: "m",
    tagName: "h3",
    "data-t-id": "slides-SecondarySlide"
  }, title), /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: "2xs",
    tagName: "span"
  }, subtitle));
};
export var SecondarySlide = compose(enhancedConnect({
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node
}), withAutoMetric.Item(function (_ref3) {
  var title = _ref3.title;
  return {
    name: 'SecondarySlide',
    title: title
  };
}))(_SecondarySlide);